var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFigma = function SvgFigma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#figma_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20a4 4 0 0 1 4-4h4v4a4 4 0 1 1-8 0Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0v8h4a4 4 0 0 0 0-8h-4Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4a4 4 0 0 0 4 4h4V0H8a4 4 0 0 0-4 4Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12a4 4 0 0 0 4 4h4V8H8a4 4 0 0 0-4 4Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "figma_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 12 12)",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgFigma;